import Modal from 'bootstrap';
import Timeline from '../modules/blocks/timeline';
import TeamModal from '../modules/blocks/team';

export default {
  init(){
    Timeline();
    TeamModal();
  }
}